import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchTagsEntity } from '../../domain/entities/BranchTagsEntity'
import type { BranchTagAdminDto } from '@/backend/market'

export class BranchTagsModel extends BranchTagsEntity {
  constructor(dataDto: BranchTagAdminDto) {
   super()
    mapEntityProperties<BranchTagsEntity>(this, dataDto, {
      exclude: ['channelName'],
      map: {
        channel: {
          name: dataDto.channelName,
          id: dataDto.channelId
        },
      }
    })
  }
}